"use client";

import { useEffect } from "react";

export function RegisterSW() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    // A service worker earns nothing against a dev server and costs a great
    // deal. `next dev` re-issues /_next/static/ URLs with a fresh
    // `?v=<timestamp>` on every reload, and cache.put() keys on the full URL,
    // so each reload stores another copy of the same font or stylesheet under a
    // new key — and sw.js only ever evicts whole caches by name, so none of it
    // comes back. One Brave profile reached 15 GB across 28k entries: of 1,500
    // sampled, just 275 distinct files, with layout.css stored 237 times.
    //
    // So outside a production build we never register, and we tear down
    // whatever an earlier build left installed — which is what frees the disk.
    if (process.env.NODE_ENV !== "production") {
      void navigator.serviceWorker
        .getRegistrations()
        .then((regs) => Promise.all(regs.map((reg) => reg.unregister())))
        .catch(() => {});
      if (typeof caches !== "undefined") {
        void caches
          .keys()
          .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
          .catch(() => {});
      }
      return;
    }

    navigator.serviceWorker.register("/sw.js").catch(() => {});
  }, []);
  return null;
}
